import { Component, Input, OnInit } from "@angular/core";
import {default as GridColumnsJSON} from './cais-audit-trail-grid-columns.json';
import { ConstantService } from "app/Shared/Services/constant-service";
import { GridService } from "app/Shared/Services/grid.service";
import { HttpErrorResponse } from "@angular/common/http";
import { CAISAuditTrailService } from "./cais-audit-trail.service";
import { UserService } from "app/Shared/Services/user.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { LowerCasePipe, NgClass, CommonModule } from "@angular/common";
import { FilterPanelComponent } from "app/Shared/Component/filter-panel/filter-panel.component";
import { MatAccordion, MatExpansionModule } from "@angular/material/expansion";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { JSONViewerComponent } from "app/Shared/Component/json-viewer/json-dialog.component";
import { TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";

@Component({
    selector: 'app-cais-audit-trail',
    imports: [MatProgressSpinner, CommonModule, FilterPanelComponent, MatAccordion, MatExpansionModule, MatChipsModule, NgClass,
        LowerCasePipe, MatTooltipModule, JSONViewerComponent, TableModule, FormsModule, ButtonModule],
    templateUrl: './cais-audit-trail.component.html',
    styleUrls: ['./cais-audit-trail.component.scss']
})
export class CAISAuditTrailComponent implements OnInit {
  @Input('SelectedRow') selectedRow: any = [];
  isDataLoading: boolean = false;
  @Input('showFilter') showFilter: boolean = false;
  @Input('staticFilter') staticFilter: boolean = true;
  @Input('rows') rows: number = 12;
  @Input('pageName') pageName!: string;
  gridColumns = GridColumnsJSON;
  DefaultFilterArray: any = [];
  isFilterLabelReset: boolean = false;
  cols = [];
  LastCAISExecutionAuditDate!: any[];
  reportDate: string = "";
  firmDesignatedID: string = "";
  inCustomerRecordID: string = "";
  customerRecordID: string = "";
  accountNumber: string = "";
  receivedFDID: string = "";
  startLimit: number = 0;
  endLimit: number = 5000;
  totalRecords: number = 0;
  CAISAuditData: any = [];
  updatedJSONObject: any;
  originalJSONObject: any;
  isJsonViewer: boolean = false;
  selectedRows: any[] = [];
  ri:any;
  
  constructor(public gridService: GridService,
    public constantService: ConstantService,
    public CAISAuditTrailService: CAISAuditTrailService,
    private userService: UserService) {
    this.getColumns();
  }

  ngOnInit() {
    const rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.totalRecords = rowcount;
    let todate: any;
    todate = this.userService.getyyyyMMddDateFormate(this.userService.CAISLastReportDate);
    this.LastCAISExecutionAuditDate = [];
    if (todate != "" || todate != undefined || todate != null) {
      this.LastCAISExecutionAuditDate[0] = (todate); // Fromdate
      this.LastCAISExecutionAuditDate[1] = (todate); // Todate
      this.defaultFilter();
    }
    this.loadData();
  }

  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'lastUpdate', 'filterby': '', 'values': this.LastCAISExecutionAuditDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Report Date', 'columnname': 'reportDate', 'filterby': '', 'values': '', 'time': '', 'datatype': 'DateRange', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Customer Record ID', 'columnname': 'customerRecordID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'In Customer Record ID', 'columnname': 'inCustomerRecordID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Received FDID', 'columnname': 'receivedFDID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'AccountNumber', 'columnname': 'accountNumber', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
  }

  loadData() {
    if (this.staticFilter) {
      this.getDialogClickData()
    }
    if (this.showFilter) {
      this.getDataOnFilter();
    }
  }

  getDialogClickData() {
    let row = this.selectedRow;
    this.reportDate = row['reportDate'];
    this.firmDesignatedID = row['firmDesignatedID'];
    this.inCustomerRecordID = row['inCustomerRecordID'];
    this.accountNumber = row['accountNumber'];
    this.receivedFDID = row['receivedFDID'];


    let payload = {
      CATReporterIMID: this.userService.getActiveMPID(),
      reportDate: this.reportDate,
      inCustomerRecordID: this.inCustomerRecordID,
      accountNumber: this.accountNumber,
      receivedFDID: ((!this.receivedFDID || this.receivedFDID.length == 0) ? this.receivedFDID : this.firmDesignatedID),
      pageName: "CAIS-Audit-Dialog",
      startLimit: this.startLimit,
      endLimit: this.endLimit
    };
    this.getData(payload);
  }

  changePage(event: any) {
    this.startLimit = event.first;
    this.endLimit = event.rows;
    this.loadData();
  }

  getDataOnFilter() {
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if(filterData[0].values.length === 2) {
      filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    let payload = {
      CATReporterIMID: this.userService.getActiveMPID(),
      pageName: "CAIS-Audit-Details",
      startLimit: this.startLimit,
      endLimit: this.endLimit,
      data: filterData
    };
    this.getData(payload);
  }

  getData(payload: any) {
    this.isDataLoading = true;
    this.CAISAuditTrailService.getData(payload)
      .subscribe({
        next: (element:any) => {
        this.isDataLoading = false;
        let dataset: any = element;
        if (dataset.data) {
          this.CAISAuditTrailService.CAISAuditTrailData = [];
          this.CAISAuditData = dataset.data;
          this.totalRecords = this.CAISAuditData.length;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.CAISAuditTrailService.CAISAuditTrailData = this.CAISAuditData;
        }
      }, error: (err: HttpErrorResponse) => {
        this.isDataLoading = false;
      }});
  }

  getColumns() {
    let column: any = this.gridColumns;
    if (column != null || column != undefined) {
      this.cols = this.gridService.getGridColumnsOftree(column);
    }
  }

  exportToCSV() {
    this.CAISAuditTrailService.exportToCSV(this.gridColumns, this.pageName, (typeof this.pageName !== 'undefined' ? [this.selectedRow] : this.DefaultFilterArray));
  }

  onJsonViewer(rowData: any) {
    this.selectedRows = [];
    this.selectedRows[0] = rowData;
    this.isJsonViewer = true;
    this.updatedJSONObject = rowData['updatedJSON'];
    this.originalJSONObject = rowData['originalJSON'];
  }

  FilterApplyFilterEvent(event: any) {
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.getDataOnFilter();
  }

}